<template>
    <div>
        <div class="col-md-12">
            <div class="card">
                <v-app>
                    <v-container fluid>
                        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <v-card outlined width="100%" class="rounded-md">
                                <order-list url="site"></order-list>
                            </v-card>
                        </v-col>
                    </v-container>
                </v-app>
            </div>
        </div>
    </div>
</template>

<script>
import OrderList from "./orderList";

export default {
    name: "allOrders",
    components: {OrderList},
    data() {
        return {
            step: 1,
            dialogPayment: false,
            payDialogInfo: {},
            payableTransaction: null,
            selectedRows: [],
            paymentLoading: false,
            data: {
                name: null,
                type: null,
                quality: null,
                recommended_sites: [],
                rivals: [],
                programming_language: null,
                site_type: null,
                support_time: null,
            },
            orderTypes: [
                {key: 'design', keyAlias: 'طراحی سایت', icon: '/media/site/aparat.png'},
                {key: 'support', keyAlias: 'پشتیبانی سایت', icon: '/media/site/aparat.png'},
                {key: 'seo', keyAlias: 'سئو سایت', icon: '/media/site/aparat.png'},
            ],
            errors: [],
            dialog: false,
            loading: false,
            errorMsg: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            items: [
                'سفارش ها',
                'ثبت سفارش جدید',
            ],
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            url: 'site',
            userInfo: {},
            tableProps: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            tablePropsDefault: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            columns: [
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.userInfo.meta.current_page - 1;
                        row = row * this.userInfo.meta.per_page;
                        return row + val.row + 1;
                    },
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'نام مجموعه',
                    name: 'name',
                    orderable: true,
                },
                {
                    label: 'نوع سفارش',
                    name: 'type',
                    orderable: true,

                },

                {
                    label: 'زبان برنامه نویسی',
                    name: 'programming_language',
                    // transform: (value, data) => {
                    //   return value.data.location ? `${value.data.location[0]} , ${value.data.location[1]}` : 'ندارد'
                    // }
                },

                {
                    label: 'نوع سایت',
                    name: 'site_type',
                    orderable: true,
                    // transform: (value, data) => {
                    //   return value.data.pack.title;
                    // }
                },


                {
                    name: 'status',
                    label: 'وضعیت',
                    handler: this.actions,
                    component: siteStatusButton,
                    event: 'action',
                    // transform: (value, data) => {
                    //   return this.getStatusBadge(value.data.status)
                    // }
                },

                {
                    label: 'عملیات',
                    name: 'actions',
                    component: actionButton,
                    handler: this.actions,
                    event: 'action',
                    permission_prefix: 'user_',
                    meta: {
                        buttons: [
                            {
                                name: "edit",
                                label: "ویرایش اطلاعات سایت",
                                icon: "pencil-alt",
                                type: 'edit',
                                action: (a, b) => {
                                    this.goto(`site/${a.id}`)
                                }
                                , permission: "user_access"
                            },

                        ]
                    }
                },
            ],
            statusBadge: '',
            userValid: true,
            isRejected: false,
            isPending: false,
            userInfoGot: false
        }
    },
    methods: {
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        step1Validate() {
            if (!this.data.name || !this.data.type) {
                this.$toast.error('لطفا اطلاعات اولیه سفارش خود را تکمیل کنید!')
                return
            }
            this.step = 2
        },
        getUserInfo() {
            this.userInfoGot = true;
            this.$modal.showLoading();
            this.requestApiGet('userInfo')
                .then(res => {
                    this.$modal.hideLoading();
                    let response = res.data.data
                    console.log(response.status)
                    if (response.status == 'accept') {
                        this.userValid = true
                        this.statusBadge = 'accept'
                    } else if (response.status == 'reject') {
                        this.isRejected = true
                        this.userValid = false
                        this.statusBadge = 'reject'
                        let _this = this;
                        this.$modal.error('اطلاعات تکمیلی نیاز به ویرایش دارد', 'اطلاعات شما دارای مشکل میباشد',
                            undefined,
                            {},
                            [
                                {
                                    text: "رفتن به صفحه تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    } else if (response.status == 'pending') {
                        this.isPending = true
                        this.userValid = false
                        this.statusBadge = 'pending'
                        this.$modal.warning('در انتظار تایید اطلاعات',
                            'در مرحله در انتظار تایید توسط پشتیبانی شما قادر به ثبت بیلبورد نمیباشید.')
                    } else {
                        this.userValid = false
                        this.statusBadge = ''
                        let _this = this;
                        this.$modal.info('اطلاعات خود را تکمیل کنید',
                            'تا زمانی که اطلاعات خود را تکمیل نکنید قادر به ثبت بیلبورد نمیباشید.',

                            undefined,
                            {},
                            [
                                {
                                    text: "تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    }
                })
                .catch(res => {
                    this.$modal.hideLoading();
                })
        },
        submit() {
            this.errors = [];
            this.requestApiPost(`site`, this.createFormData(this.data))
                .then((res) => {
                    if (res.status && res.status == 201) {
                        this.getSites()
                        this.tab = 0
                        this.$toast.success('با موفقیت ثبت شد.')
                    } else {
                        this.$toast.warning('لطفا مجددا تلاش کنید')
                    }
                })
                .catch((e) => {
                    this.$toast.error('خطا در ثبت')
                    this.errors = e.response.data.errors
                })
                .finally(() => {
                    this.$modal.hideLoading();
                })
        },
        pay(transactionId) {
            if (this.payDialogInfo.payments.type === 'final') {

                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })


            } else {
                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })

            }
        },
        getStatusBadge(status) {
            let text = status;
            let color = 'light'

            switch (status) {
                case "pending":
                    text = 'در انتظار تایید';
                    color = 'warning'
                    break;


                case "accept":
                    text = 'منتظر پرداخت';
                    color = 'info'
                    break

                case "reject":
                    text = 'رد شده';
                    color = 'danger'
                    break

                case "disable":
                    text = 'مسدود';
                    color = 'light'
                    break
            }

            return `<span class="badge badge-${color}">${text}</span>`;
        },
        selectAll(c) {
            window.Vue.$emit("selectedAllCheckbox", c);
        },
        change(data, checked) {
            if (checked) {
                this.selectedRows.push(data.id);
            } else {
                let index = this.selectedRows.indexOf(data.id)
                this.selectedRows = [
                    ...this.selectedRows.slice(0, index),
                    ...this.selectedRows.slice(index + 1, this.selectedRows.length)
                ]

            }
            window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

        },
        getSites(url = this.url, params = this.tableProps) {
            this.$modal.showLoading();
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.$modal.hideLoading();
                if (!this.userInfoGot) {
                    this.getUserInfo();
                }
            })
        },
        reloadTable(params) {
            this.getSites(this.url, params)
        },
        actions(data, type) {
            this[type](data)
        },
        edit(data) {
            this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
        },
        information(data) {
            this.$router.push({name: 'admin.users.information', params: {id: data.id}})
        },
        checkout(data) {
            this.$modal.showLoading();
            this.getUserTokenWithId(data.id)
                .then((token) => {
                    loginRollback.addLogin(this.getUser().name, jwtService.getToken())
                    jwtService.saveToken(token)
                    window.location.reload();
                }).catch((e) => {
                this.$toast.error("error")
            })
                .finally(() => {
                    this.$modal.hideLoading();
                })
        },
    },
}
</script>

<style scoped>

</style>